/* eslint-disable no-lone-blocks */
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Home from './pages/Home/Home';
import SignIn from './components/UserAuth/SignIn';
import SignUp from './components/UserAuth/SignUp';
import UserDashboard from './pages/UserDashboard/UserDashboard';
import ProductPage from './pages/ProductPage/ProductPage';
import ShopAllPage from './pages/ShopAllPage/ShopAllPage';
// AdminRoutes is expected to contain the actual AdminPanel and its sub-routes
import AdminRoutes from './routes/AdminRoutes'; 
import AdminSignUp from './components/AdminItems/AdminAuth/AdminSignUp';
import AdminSignIn from './components/AdminItems/AdminAuth/AdminSignIn';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ComingSoon from './pages/ComingSoon/ComingSoon';
import Contact from './pages/Contact/Contact';
import NewPage from './pages/NewPage/NewPage';

const App = () => {
  {/* Admin Authentication Pages - these don't need protection 
   
         
    Admin Panel and its nested routes, protected
    This ensures only admins can access anything under /admin/ 
    x
         
    User Dashboard - protect this so only logged-in users can see it 
   
         
    Global Pages - accessible to anyone 
   
  */}
  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
        <Route path="/admin/*" element={<ProtectedRoute adminOnly={true}><AdminRoutes /></ProtectedRoute>} />
        <Route path="/product-view" element={<ProductPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shirts" element={<ShopAllPage />} />
        <Route path="/men" element={<ShopAllPage />} />
        <Route path="/sale" element={<ShopAllPage />} />
        <Route path="/apex" element={<ShopAllPage />} />
        <Route path="/maison" element={<ShopAllPage />} />
        <Route path="/new" element={<NewPage />} />
        <Route path="/shop-all" element={<ShopAllPage />} />
        <Route path="/sign-up" elementz={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/home" element={<Home />} /> 
      
        <Route path="/auth/amvoss/sign-in" element={<AdminSignIn />} />
        <Route path="/auth/amvoss/sign-up" element={<AdminSignUp />} />
        <Route path="/" element={<ComingSoon />} /> 
      </Routes>
    </Router>
  );

}

export default App;



